import DamageButton from '@/components/buttons/Damage.vue';
import DamageProxy from '@/proxies/Damage/DamageProxy';

export default {
  components: {
    DamageButton,
  },
  methods: {
    damageClick() {
      if (this.item.damage) {
        this.$router.push({
          name: 'damages.show',
          params: { damageUuid: this.item.damage },
        });
      } else {
        new DamageProxy().create({
          damagable_uuid: this.item.uuid,
          damagable_type: this.damagableType,
        })
          .then((response) => {
            this.$router.push({
              name: 'damages.show',
              params: { damageUuid: response.data.data.damage.uuid },
            });
          })
          .catch((error) => {
            console.warn(error);
            this.$store.dispatch('page/displaySnackbar', {
              text: 'Ошибка',
              color: 'red darken-3',
              timeout: 6000,
            });
          })
          .finally(() => {
          });
      }
    },
  },
};
